import { notificationService, userService } from "./services";
import { Promise } from "es6-promise";

export const getNotifications = params => {
  return new Promise(function(resolve, reject) {
    resolve(notificationService.getAll(params));
  });
};

export const getCompanyInfo = email => {
  return new Promise(function(resolve, reject) {
    resolve(userService.getCompanyInfo(email));
  });
};
